module.exports = __webpack_public_path__ + "img/icon_1_active.a8e0395b.png";